import { useBooleanFlag } from '@trm/feature-flags/web';

export const useFacebookLoginFlag = () => ({
  isFacebookLoginEnabled: useBooleanFlag('enable-social-login-facebook', false),
});
